import React, { useState, useEffect, useCallback } from "react";
const SPINNER_STYLE = `
 @keyframes spin { to { transform: rotate(360deg); } }
 @keyframes pulse { 0%,100%{opacity:.8}50%{opacity:.4} }
`;
const ACCENT = "#3fd4c7";
const AMBER = "#f39c12";
const ROED = "#e74c3c";
const LILLA = "#a78bfa";
const GROEN = "#22c55e";
const BG = "rgba(8,12,30,0.55)";
const KANT = "1px solid rgba(63,212,199,0.12)";
const STATUS_CFG = {
 AFVENTER_ANALYSE: { label: "Afventer analyse", farve: "#64748b" },
 UNDER_REVISION: { label: "Afventer re-analyse", farve: AMBER },
 ANALYSERET: { label: "Analyseret", farve: LILLA },
 GODKENDT: { label: "Godkendt", farve: ACCENT },
 AFVIST: { label: "Afvist", farve: ROED },
 MODIFICERET: { label: "Modificeret", farve: AMBER },
};
const PROJEKT_STATUS_CFG = {
 PLANLAGT: { label: "Planlagt", farve: "#64748b" },
 // IGANGVAERENDE = agent arbejdede aktivt inden for 30 min → grøn
 IGANGVAERENDE: { label: "I gang", farve: ACCENT },
 // AFVENTER_AGENT = IGANGVAERENDE fase men ingen aktivitet 30 min–4 timer → gul
 AFVENTER_AGENT: { label: "Afventer agent", farve: AMBER },
 // GAAET_I_STAA = IGANGVAERENDE fase men ingen aktivitet >4 timer → rød
 GAAET_I_STAA: { label: "Gået i stå", farve: ROED },
 FULDFOERT: { label: "Fuldført", farve: GROEN },
 PAUSET: { label: "Pauset", farve: AMBER },
 ANNULLERET: { label: "Annulleret", farve: ROED },
};
const OPGAVE_STATUS_CFG = {
 AFVENTER: { label: "Afventer", farve: "#64748b" },
 KOERER: { label: "I gang", farve: ACCENT },
 FULDFOERT: { label: "Fuldført", farve: GROEN },
 FEJLET: { label: "Fejlet", farve: ROED },
 GODKENDT: { label: "Godkendt", farve: ACCENT },
 AFVIST: { label: "Afvist", farve: ROED },
};
const AFD_LABELS = {
 kode: "Kode", analyse: "Analyse", marketing: "Marketing",
 design_ux: "Design/UX", qa_testing: "QA & Test", oekonomi: "Økonomi",
 "investering-vaekst": "Vækst", ai_ml: "AI & ML", deploy: "Deploy",
 overvaagning: "Overvågning", kommunikation: "Komm.",
};
const afdLabel = (k) => AFD_LABELS[k] || k;
function formatTid(kl) {
 if (!kl) return "—";
 return new Date(kl).toLocaleString("da-DK", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
}
async function api(sti, metode = "GET", data) {
 const r = await fetch(`/api${sti}`, {
 method: metode,
 credentials: "include",
 headers: { "Content-Type": "application/json" },
 body: data ? JSON.stringify(data) : undefined,
 });
 return r.json();
}
// ── Idé-kort ────────────────────────────────────────────────────
function IdeKort({ ide, onOpdater }) {
 const [udvidet, setUdvidet] = useState(false);
 const [vis_godkend, setVisGodkend] = useState(false);
 const [godkend_kommentar, setGodkendKommentar] = useState("");
 const [vis_modifier, setVisModifier] = useState(false);
 const [modifier_tekst, setModifierTekst] = useState("");
 const [vis_dialog, setVisDialog] = useState(false);
 const [dialog_tekst, setDialogTekst] = useState("");
 const [sender, setSender] = useState(false);
 const [godkendt_ok, setGodkendtOk] = useState(false);
 const er_revision = ide.status === "AFVENTER_ANALYSE" && !!ide.modificer_instruktion;
 const cfg_key = er_revision ? "UNDER_REVISION" : ide.status;
 const cfg = STATUS_CFG[cfg_key] || STATUS_CFG.AFVENTER_ANALYSE;
 // Robust håndtering: analyse_resultat kan være streng (gammel API), objekt eller null
 const analyse = (() => {
 try {
 if (!ide.analyse_resultat) return null;
 if (typeof ide.analyse_resultat === "string") return JSON.parse(ide.analyse_resultat);
 if (typeof ide.analyse_resultat === "object") return ide.analyse_resultat;
 return null;
 } catch { return null; }
 })();
 const dialog = Array.isArray(ide.dialog) ? ide.dialog : [];
 const ANBEFALING_FARVE = { godkend: ACCENT, afvis: ROED, modificer: AMBER };
 const anbefaling_farve = analyse?.anbefaling ? ANBEFALING_FARVE[analyse.anbefaling] || LILLA : LILLA;
 async function godkend() {
 setSender(true);
 try {
 const result = await api(`/os/ideer/${ide.id}/godkend`, "POST",
 { kommentar: godkend_kommentar.trim() || undefined });
 if (result?.projekt_id) {
 setGodkendtOk(true);
 setTimeout(() => { setGodkendtOk(false); onOpdater(); }, 2500);
 } else {
 onOpdater();
 }
 } finally {
 setSender(false);
 setVisGodkend(false);
 setGodkendKommentar("");
 }
 }
 async function afvis() {
 setSender(true);
 try { await api(`/os/ideer/${ide.id}/afvis`, "POST"); onOpdater(); }
 finally { setSender(false); }
 }
 async function modificer() {
 if (!modifier_tekst.trim()) return;
 setSender(true);
 try {
 await api(`/os/ideer/${ide.id}/modificer`, "POST", { tekst: modifier_tekst.trim() });
 setVisModifier(false);
 setModifierTekst("");
 onOpdater();
 } finally { setSender(false); }
 }
 async function sendDialog() {
 if (!dialog_tekst.trim()) return;
 setSender(true);
 try {
 await api(`/os/ideer/${ide.id}/dialog`, "POST", { tekst: dialog_tekst.trim() });
 setDialogTekst("");
 onOpdater();
 } finally { setSender(false); }
 }
 return (
 <div style={{ background: BG,
 border: ide.status === "ANALYSERET" ? `1px solid ${anbefaling_farve}33` : KANT,
 borderRadius: 14, padding: "16px 20px", marginBottom: 12 }}>
 {/* Status + tidspunkt */}
 <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6, flexWrap: "wrap" }}> <span style={{ fontSize: 10, fontWeight: 700, color: cfg.farve,
 background: `${cfg.farve}20`, borderRadius: 5, padding: "2px 8px", textTransform: "uppercase" }}>
 {cfg.label}
 </span> <span style={{ fontSize: 11, color: "#64748b" }}>{formatTid(ide.oprettet_kl)}</span>
 {analyse?.impact_score && (
 <span style={{ fontSize: 10, fontWeight: 700, color: ACCENT, background: "rgba(63,212,199,0.12)",
 borderRadius: 5, padding: "2px 8px" }}>
 Impact {analyse.impact_score}/10
 </span>
 )}
 {dialog.length > 0 && (
 <span style={{ fontSize: 10, color: LILLA, background: `${LILLA}15`,
 borderRadius: 5, padding: "2px 8px" }}>
 {dialog.length}
 </span>
 )}
 </div>
 {/* Idé tekst */}
 <div style={{ fontSize: 14, fontWeight: 600, color: "#e2e8f0", lineHeight: 1.5, marginBottom: 6 }}>
 {ide.tekst}
 </div>
 {/* Revision-instruktion */}
 {er_revision && (
 <div style={{ background: `${AMBER}12`, border: `1px solid ${AMBER}30`, borderRadius: 8,
 padding: "8px 12px", marginBottom: 8 }}> <span style={{ fontSize: 10, fontWeight: 700, color: AMBER, textTransform: "uppercase",
 letterSpacing: 0.5 }}>Revisions-instruktion: </span> <span style={{ fontSize: 12, color: AMBER }}>{ide.modificer_instruktion}</span> </div>
 )}
 {/* Analyse (ANALYSERET) */}
 {analyse && ide.status === "ANALYSERET" && (
 <div style={{ background: "rgba(0,0,0,0.25)", borderRadius: 10, padding: "12px 14px", marginBottom: 10,
 borderLeft: `3px solid ${anbefaling_farve}` }}>
 {analyse.vurdering && (
 <div style={{ fontSize: 13, color: "#c0d0e8", marginBottom: 8, lineHeight: 1.6 }}>
 {analyse.vurdering}
 </div>
 )}
 <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: analyse.fordele?.length ? 8 : 0 }}>
 {analyse.strategi_fit && (
 <div style={{ fontSize: 11, color: "#64748b" }}>
 Strategi-fit: <span style={{ fontWeight: 700,
 color: analyse.strategi_fit === "høj" ? ACCENT : analyse.strategi_fit === "lav" ? ROED : AMBER }}>
 {analyse.strategi_fit}
 </span> </div>
 )}
 {analyse.anbefaling && (
 <div style={{ fontSize: 11, color: "#64748b" }}>
 Anbefaling: <span style={{ color: anbefaling_farve, fontWeight: 700, textTransform: "uppercase" }}>
 {analyse.anbefaling}
 </span> </div>
 )}
 {analyse.estimat && (
 <div style={{ fontSize: 11, color: "#64748b" }}>
 Estimat: <span style={{ color: "#9db3c8" }}>{analyse.estimat}</span> </div>
 )}
 </div>
 {analyse.anbefaling_tekst && (
 <div style={{ fontSize: 12, color: "#7a8fa6", fontStyle: "italic",
 marginBottom: analyse.fordele?.length ? 8 : 0 }}>
 {analyse.anbefaling_tekst}
 </div>
 )}
 <button onClick={() => setUdvidet(!udvidet)} style={{
 background: "none", border: "none", color: "#4a5568", cursor: "pointer",
 fontSize: 11, padding: "4px 0", marginTop: 4 }}>
 {udvidet ? "▲ Skjul detaljer" : "▼ Fordele & risici"}
 </button>
 {udvidet && (
 <div style={{ marginTop: 8 }}>
 {analyse.fordele?.length > 0 && (
 <div style={{ marginBottom: 8 }}> <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600, marginBottom: 4 }}>FORDELE</div>
 {analyse.fordele.map((f, i) => (
 <div key={i} style={{ fontSize: 12, color: "#a0b4c8", marginBottom: 2 }}>• {f}</div>
 ))}
 </div>
 )}
 {analyse.risici?.length > 0 && (
 <div> <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600, marginBottom: 4 }}>RISICI</div>
 {analyse.risici.map((r, i) => (
 <div key={i} style={{ fontSize: 12, color: "#a0b4c8", marginBottom: 2 }}>• {r}</div>
 ))}
 </div>
 )}
 </div>
 )}
 </div>
 )}
 {/* Analyse kompakt (GODKENDT/AFVIST) */}
 {analyse && ide.status !== "ANALYSERET" && ide.status !== "AFVENTER_ANALYSE" && (
 <div> <button onClick={() => setUdvidet(!udvidet)} style={{
 background: "none", border: "none", color: LILLA, cursor: "pointer",
 fontSize: 12, padding: "2px 0", marginBottom: udvidet ? 10 : 0 }}>
 {udvidet ? "▲ Skjul analyse" : "▼ Vis analyse"}
 </button>
 {udvidet && (
 <div style={{ background: "rgba(0,0,0,0.3)", borderRadius: 10, padding: "12px 14px", marginBottom: 10 }}>
 {analyse.vurdering && (
 <div style={{ fontSize: 12, color: "#9db3c8", lineHeight: 1.5 }}>{analyse.vurdering}</div>
 )}
 </div>
 )}
 </div>
 )}
 {/* Afventer analyse spinner */}
 {ide.status === "AFVENTER_ANALYSE" && (
 <div style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 10,
 background: er_revision ? `${AMBER}10` : "rgba(100,116,139,0.08)",
 border: `1px solid ${er_revision ? AMBER + "30" : "rgba(100,116,139,0.2)"}`,
 borderRadius: 10, padding: "10px 14px" }}> <div style={{ width: 14, height: 14, borderRadius: "50%", flexShrink: 0,
 border: `2px solid ${er_revision ? AMBER + "40" : "rgba(163,212,199,0.3)"}`,
 borderTopColor: er_revision ? AMBER : ACCENT,
 animation: "spin 1s linear infinite" }} /> <span style={{ fontSize: 12, color: er_revision ? AMBER : "#7a8fa6" }}>
 {er_revision
 ? "Revision sendt — kør /idé-analyse for at genbehandle"
 : "Analyse igangsat — afventer svar fra afdelingerne"}
 </span> </div>
 )}
 {/* Godkend success */}
 {godkendt_ok && (
 <div style={{ marginTop: 12, background: "rgba(6,214,160,0.10)", border: "1px solid rgba(6,214,160,0.3)",
 borderRadius: 8, padding: "10px 14px", fontSize: 12, color: ACCENT, fontWeight: 600 }}>
 Godkendt — projekt oprettet og afdelinger notificeret. Se Projekter-fanen.
 </div>
 )}
 {/* Handlingsknapper */}
 {ide.status === "ANALYSERET" && !godkendt_ok && (
 <div style={{ marginTop: 12, display: "flex", gap: 8, flexWrap: "wrap" }}> <button disabled={sender} onClick={() => { setVisGodkend(!vis_godkend); setVisModifier(false); setVisDialog(false); }} style={{
 padding: "7px 16px", background: vis_godkend ? "rgba(6,214,160,0.2)" : "rgba(6,214,160,0.12)",
 border: "1px solid rgba(6,214,160,0.35)", borderRadius: 8, color: ACCENT,
 cursor: "pointer", fontWeight: 700, fontSize: 12, opacity: sender ? 0.6 : 1 }}>
 Godkend
 </button> <button disabled={sender} onClick={() => { setVisModifier(!vis_modifier); setVisGodkend(false); setVisDialog(false); }} style={{
 padding: "7px 16px", background: vis_modifier ? `${AMBER}20` : `${AMBER}10`,
 border: `1px solid ${AMBER}30`, borderRadius: 8, color: AMBER, cursor: "pointer", fontWeight: 700, fontSize: 12 }}>
 Modificer
 </button> <button disabled={sender} onClick={afvis} style={{
 padding: "7px 16px", background: "rgba(231,76,60,0.1)", border: "1px solid rgba(231,76,60,0.25)",
 borderRadius: 8, color: ROED, cursor: "pointer", fontWeight: 700, fontSize: 12, opacity: sender ? 0.6 : 1 }}>
 Afvis
 </button> <button onClick={() => { setVisDialog(!vis_dialog); setVisGodkend(false); setVisModifier(false); }} style={{
 padding: "7px 14px", background: vis_dialog ? `${LILLA}15` : "none",
 border: vis_dialog ? `1px solid ${LILLA}40` : KANT, borderRadius: 8,
 color: dialog.length > 0 ? LILLA : "#64748b", cursor: "pointer", fontSize: 12 }}>
 {dialog.length > 0 ? `Spar (${dialog.length})` : "Spar om idéen"}
 </button> </div>
 )}
 {/* Godkend form */}
 {vis_godkend && (
 <div style={{ marginTop: 10, padding: "14px 16px", background: "rgba(6,214,160,0.04)",
 border: "1px solid rgba(6,214,160,0.15)", borderRadius: 10 }}> <div style={{ fontSize: 12, color: ACCENT, fontWeight: 600, marginBottom: 6 }}>
 Renés instruktion til projektet
 </div> <div style={{ fontSize: 11, color: "#4a5568", marginBottom: 8 }}>
 Valgfrit — følger projektet og vises i Projekter-fanen under "Renés instruktion".
 </div> <textarea
 value={godkend_kommentar} onChange={e => setGodkendKommentar(e.target.value)}
 placeholder="Fx: Prioriter mobile-first · brug eksisterende design-system · hold det simpelt…"
 rows={2}
 style={{ width: "100%", boxSizing: "border-box", background: "rgba(255,255,255,0.03)", border: KANT,
 borderRadius: 8, color: "#e8eaf6", padding: "8px 12px", fontSize: 12,
 resize: "vertical", fontFamily: "inherit" }}
 /> <div style={{ display: "flex", gap: 8, marginTop: 8 }}> <button disabled={sender} onClick={godkend} style={{
 padding: "7px 18px", background: "rgba(6,214,160,0.15)", border: "1px solid rgba(6,214,160,0.4)",
 borderRadius: 8, color: ACCENT, cursor: "pointer", fontWeight: 700, fontSize: 12, opacity: sender ? 0.6 : 1 }}>
 {sender ? "Godkender…" : godkend_kommentar.trim() ? " Godkend med instruktion" : " Godkend"}
 </button> <button onClick={() => setVisGodkend(false)} style={{
 padding: "7px 12px", background: "none", border: KANT, borderRadius: 8,
 color: "#64748b", cursor: "pointer", fontSize: 12 }}>
 Annuller
 </button> </div> </div>
 )}
 {/* Modificer form */}
 {vis_modifier && (
 <div style={{ marginTop: 10, padding: "14px 16px", background: `${AMBER}08`,
 border: `1px solid ${AMBER}25`, borderRadius: 10 }}> <div style={{ fontSize: 12, color: AMBER, fontWeight: 600, marginBottom: 4 }}>
 Instruktion til analyse-agenten
 </div> <div style={{ fontSize: 11, color: "#4a5568", marginBottom: 8 }}>
 Agenten reviderer analysen baseret på din instruktion. Idéen og den eksisterende analyse bevares — ingen ny idé oprettes.
 </div> <textarea
 value={modifier_tekst} onChange={e => setModifierTekst(e.target.value)}
 placeholder="Hvad skal præciseres eller ændres? Fx: 'Opdel i to projekter' · 'Fokuser på mobile-first' · 'Beregn ROI mere konservativt'"
 rows={3}
 style={{ width: "100%", boxSizing: "border-box", background: "rgba(255,255,255,0.04)", border: KANT,
 borderRadius: 8, color: "#e8eaf6", padding: "8px 12px", fontSize: 13,
 resize: "vertical", fontFamily: "inherit" }}
 /> <div style={{ display: "flex", gap: 8, marginTop: 8 }}> <button disabled={sender || !modifier_tekst.trim()} onClick={modificer} style={{
 padding: "7px 16px", background: `${AMBER}25`, border: `1px solid ${AMBER}55`,
 borderRadius: 8, color: AMBER, fontWeight: 700, fontSize: 12,
 cursor: modifier_tekst.trim() ? "pointer" : "not-allowed",
 opacity: (modifier_tekst.trim() && !sender) ? 1 : 0.5 }}>
 Send til re-analyse
 </button> <button onClick={() => setVisModifier(false)} style={{
 padding: "7px 12px", background: "none", border: KANT, borderRadius: 8,
 color: "#64748b", cursor: "pointer", fontSize: 12 }}>
 Annuller
 </button> </div> </div>
 )}
 {/* Dialog panel */}
 {vis_dialog && (
 <div style={{ marginTop: 10, padding: "14px 16px", background: `${LILLA}06`,
 border: `1px solid ${LILLA}25`, borderRadius: 10 }}> <div style={{ fontSize: 12, color: LILLA, fontWeight: 600, marginBottom: 10 }}>
 Dialog om idéen
 </div>
 {dialog.length === 0 && (
 <div style={{ fontSize: 12, color: "#4a5568", marginBottom: 10, fontStyle: "italic" }}>
 Ingen dialog endnu. Skriv spørgsmål eller kommentarer — de indgår i næste analyse-kørsel.
 </div>
 )}
 {dialog.map((msg, i) => (
 <div key={i} style={{
 background: msg.fra === "rene" ? "rgba(255,255,255,0.04)" : `${LILLA}12`,
 border: msg.fra === "rene" ? KANT : `1px solid ${LILLA}25`,
 borderRadius: 8, padding: "8px 12px", marginBottom: 6 }}> <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}> <span style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase",
 color: msg.fra === "rene" ? "#9db3c8" : LILLA }}>
 {msg.fra === "rene" ? "René" : "Agent"}
 {msg.type === "modification_request" && " · revision"}
 </span> <span style={{ fontSize: 10, color: "#4a5568" }}>{formatTid(msg.kl)}</span> </div> <div style={{ fontSize: 12, color: "#c0d0e8", lineHeight: 1.5 }}>{msg.tekst}</div> </div>
 ))}
 <textarea
 value={dialog_tekst} onChange={e => setDialogTekst(e.target.value)}
 placeholder="Stil spørgsmål, bed om alternativer eller commenter analysen…"
 rows={2}
 style={{ width: "100%", boxSizing: "border-box", background: "rgba(255,255,255,0.04)", border: KANT,
 borderRadius: 8, color: "#e8eaf6", padding: "8px 12px", fontSize: 12,
 resize: "vertical", fontFamily: "inherit", marginBottom: 8 }}
 /> <div style={{ display: "flex", gap: 8 }}> <button disabled={sender || !dialog_tekst.trim()} onClick={sendDialog} style={{
 padding: "7px 14px", background: `${LILLA}20`, border: `1px solid ${LILLA}40`,
 borderRadius: 8, color: LILLA, fontWeight: 700, fontSize: 12,
 cursor: dialog_tekst.trim() ? "pointer" : "not-allowed",
 opacity: (dialog_tekst.trim() && !sender) ? 1 : 0.5 }}>
 Send kommentar
 </button> <button onClick={() => setVisDialog(false)} style={{
 padding: "7px 12px", background: "none", border: KANT, borderRadius: 8,
 color: "#64748b", cursor: "pointer", fontSize: 12 }}>
 Luk
 </button> </div> </div>
 )}
 </div>
 );
}
// ── Idéer-fane ──────────────────────────────────────────────────
function IdeerFane({ onOpdaterTæller }) {
 const [ideer, setIdeer] = useState([]);
 const [loader, setLoader] = useState(true);
 const [fejl, setFejl] = useState(null);
 const [ny_tekst, setNyTekst] = useState("");
 const [sender, setSender] = useState(false);
 const [status_filter, setStatusFilter] = useState("");
 const hent = useCallback(async () => {
 setLoader(true);
 setFejl(null);
 try {
 const sti = status_filter ? `/os/ideer?status=${status_filter}` : "/os/ideer";
 const d = await api(sti);
 if (d?.fejl) { setFejl(d.fejl); return; }
 const liste = d.ideer || [];
 setIdeer(liste);
 // Badge tæller både AFVENTER_ANALYSE og ANALYSERET (venter på Renés beslutning)
 onOpdaterTæller?.(liste.filter(i =>
 i.status === "AFVENTER_ANALYSE" || i.status === "ANALYSERET"
 ).length || 0);
 } catch (e) {
 setFejl("Kunne ikke hente idéer — prøv igen");
 } finally {
 setLoader(false);
 }
 }, [status_filter, onOpdaterTæller]);
 // Hent ved mount og ved filter-skift
 useEffect(() => { hent(); }, [hent]);
 // Auto-refresh hvert 30 sekund så nye agent-idéer dukker op uden hård genindlæsning
 useEffect(() => {
 const id = setInterval(hent, 30000);
 return () => clearInterval(id);
 }, [hent]);
 async function opretIdé() {
 if (!ny_tekst.trim()) return;
 setSender(true);
 try {
 await api("/os/ideer", "POST", { tekst: ny_tekst.trim() });
 setNyTekst("");
 hent();
 } finally {
 setSender(false);
 }
 }
 return (
 <div> <div style={{ background: "rgba(63,212,199,0.05)", border: KANT, borderRadius: 14,
 padding: "16px 20px", marginBottom: 24 }}> <div style={{ fontSize: 13, fontWeight: 700, color: ACCENT, marginBottom: 10 }}>Ny idé</div> <textarea
 value={ny_tekst} onChange={e => setNyTekst(e.target.value)}
 placeholder="Beskriv idéen — hvad vil du opnå, og hvorfor er det relevant nu?"
 rows={3}
 style={{ width: "100%", boxSizing: "border-box", background: "rgba(255,255,255,0.04)", border: KANT,
 borderRadius: 8, color: "#e8eaf6", padding: "10px 14px", fontSize: 13,
 resize: "vertical", fontFamily: "inherit" }}
 onKeyDown={e => { if (e.key === "Enter" && e.ctrlKey) opretIdé(); }}
 /> <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}> <span style={{ fontSize: 11, color: "#4a5568" }}>Ctrl+Enter for at sende</span> <button disabled={sender || !ny_tekst.trim()} onClick={opretIdé} style={{
 padding: "8px 20px", background: "rgba(6,214,160,0.15)", border: "1px solid rgba(6,214,160,0.4)",
 borderRadius: 8, color: ACCENT, fontWeight: 700, fontSize: 13,
 cursor: ny_tekst.trim() ? "pointer" : "not-allowed", opacity: ny_tekst.trim() ? 1 : 0.5 }}>
 {sender ? "Sender…" : "Send til analyse"}
 </button> </div> </div> <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap" }}>
 {[["", "Alle"], ...Object.entries(STATUS_CFG).map(([k, v]) => [k, v.label])].map(([k, l]) => (
 <button key={k} onClick={() => setStatusFilter(k)} style={{
 padding: "5px 14px", borderRadius: 20, border: KANT, cursor: "pointer", fontSize: 12,
 background: status_filter === k ? "rgba(63,212,199,0.12)" : "none",
 color: status_filter === k ? ACCENT : "#64748b",
 fontWeight: status_filter === k ? 700 : 400 }}>
 {l}
 </button>
 ))}
 </div> <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}> <div style={{ fontSize: 13, color: "#7a8fa6" }}>
 {loader ? "Henter…" : `${ideer.length} idéer`}
 </div> <button onClick={hent} style={{ background: "none", border: KANT, borderRadius: 6,
 color: "#64748b", cursor: "pointer", fontSize: 11, padding: "4px 10px" }}>
 ↻ Opdater
 </button> </div>
 {fejl && (
 <div style={{ background: "rgba(231,76,60,0.08)", border: "1px solid rgba(231,76,60,0.25)",
 borderRadius: 10, padding: "10px 14px", marginBottom: 14,
 fontSize: 13, color: ROED, display: "flex", alignItems: "center", justifyContent: "space-between" }}> <span>{fejl}</span> <button onClick={hent} style={{ background: "none", border: KANT, borderRadius: 6,
 color: ROED, cursor: "pointer", fontSize: 11, padding: "4px 10px" }}>
 Prøv igen
 </button> </div>
 )}
 {!loader && !fejl && ideer.length === 0 && (
 <div style={{ color: "#4a5568", fontSize: 14, padding: "48px 0", textAlign: "center" }}>
 {status_filter ? "Ingen idéer med denne status" : "Ingen idéer endnu — skriv den første herover"}
 </div>
 )}
 {ideer.map(ide => <IdeKort key={ide.id} ide={ide} onOpdater={hent} />)}
 </div>
 );
}
// ── Fase-hjælpere ───────────────────────────────────────────────
function getNuværendeFase(p) {
 if (!Array.isArray(p.faser) || p.faser.length === 0) return null;
 return p.faser
 .filter(f => f.status === "IGANGVAERENDE")
 .sort((a, b) => b.fase_nummer - a.fase_nummer)[0] || null;
}
const FASE_STATUS_CFG = {
 PLANLAGT: { label: "Planlagt", farve: "#64748b" },
 // IGANGVAERENDE = agent aktiv inden for 30 min → grøn
 IGANGVAERENDE: { label: "I gang", farve: ACCENT },
 // AFVENTER_AGENT = IGANGVAERENDE men inaktiv 30 min–4 timer → gul
 AFVENTER_AGENT: { label: "Afventer agent", farve: AMBER },
 // GAAET_I_STAA = IGANGVAERENDE men inaktiv >4 timer → rød
 GAAET_I_STAA: { label: "Gået i stå", farve: ROED },
 GODKENDT: { label: "Godkendt", farve: GROEN },
 AFSLUTTET: { label: "Afsluttet", farve: GROEN },
 ANNULLERET: { label: "Revideret", farve: AMBER },
};
// ── Projekter-fane ──────────────────────────────────────────────
function ProjekterFane({ onAfventerTæller }) {
 const [projekter, setProjekter] = useState([]);
 const [loader, setLoader] = useState(true);
 const [udvidet, setUdvidet] = useState({});
 const [handlinger, setHandlinger] = useState({});
 const [modificerTekst, setModificerTekst] = useState({});
 const [godkendtBesked, setGodkendtBesked] = useState(null);
 const [redigerModal, setRedigerModal] = useState(null);
 const [redigerData, setRedigerData] = useState({});
 const [gemmerFeedback, setGemmerFeedback] = useState(false);
 const [visAnnullerede, setVisAnnullerede] = useState(false);
 const hent = useCallback(async () => {
 setLoader(true);
 try {
 const d = await api("/os/projekter");
 setProjekter(d.projekter || []);
 } finally {
 setLoader(false);
 }
 }, []);
 useEffect(() => { hent(); }, [hent]);
 // 60s fallback-polling — sikrer live-opdatering selv uden aktive opgaver
 useEffect(() => {
 const id = setInterval(hent, 60000);
 return () => clearInterval(id);
 }, [hent]);
 useEffect(() => {
 const harAktive = projekter.some(p =>
 Array.isArray(p.opgaver) && p.opgaver.some(o => o.status === "AFVENTER" || o.status === "KOERER")
 );
 if (harAktive) {
 const id = setInterval(hent, 30000);
 return () => clearInterval(id);
 }
 // Ingen aktive opgaver — men en fase kan stadig vente på auto-avancer.
 // Hent igen om 5s for at fange eventuelle fase-statusopdateringer.
 const harIgangvaerende = projekter.some(p =>
 Array.isArray(p.faser) && p.faser.some(f => f.status === "IGANGVAERENDE")
 );
 if (!harIgangvaerende) return;
 const t = setTimeout(hent, 5000);
 return () => clearTimeout(t);
 }, [projekter, hent]);
 // "Klar til deploy" — viser kun aktive projekter hvor deploy-fase er PLANLAGT og alle andre faser er GODKENDT
 const afventerGodkendelse = projekter.filter(p => {
 if (p.status === "ANNULLERET" || p.status === "FULDFOERT") return false;
 const faser = Array.isArray(p.faser) ? p.faser : [];
 const deployFase = faser.find(f =>
 (f.fase_navn || "").toLowerCase().includes("deploy") || f.fase_nummer >= 5
 );
 if (!deployFase || deployFase.status !== "PLANLAGT") return false;
 const andreFaser = faser.filter(f => f.id !== deployFase.id);
 return andreFaser.length > 0 && andreFaser.every(f => f.status === "GODKENDT");
 });
 useEffect(() => {
 if (onAfventerTæller) onAfventerTæller(afventerGodkendelse.length);
 }, [afventerGodkendelse.length, onAfventerTæller]);
 const toggleUdvidet = (id) => setUdvidet(prev => ({ ...prev, [id]: !prev[id] }));
 async function godkendProjekt(p) {
 const fase = getNuværendeFase(p);
 setHandlinger(prev => ({ ...prev, [p.id]: "loading" }));
 try {
 await api(`/os/projekter/${p.id}/godkend`, "PATCH", {});
 setGodkendtBesked(` Godkendt — ${p.titel}${fase && fase.fase_nummer > 1 ? ` (Fase ${fase.fase_nummer})` : ""}`);
 setTimeout(() => setGodkendtBesked(null), 3500);
 await hent();
 } finally {
 setHandlinger(prev => { const n = { ...prev }; delete n[p.id]; return n; });
 }
 }
 async function afvisProjekt(p) {
 setHandlinger(prev => ({ ...prev, [p.id]: "loading" }));
 try {
 await api(`/os/projekter/${p.id}/afvis`, "PATCH", {});
 await hent();
 } finally {
 setHandlinger(prev => { const n = { ...prev }; delete n[p.id]; return n; });
 }
 }
 function aabneRedigering(p) {
 setRedigerData({ fejlbeskrivelse: p.fejlbeskrivelse || "", rene_feedback: p.rene_feedback || "", ny_ide: "" });
 setRedigerModal(p);
 }
 async function gemFeedback() {
 if (!redigerModal) return;
 setGemmerFeedback(true);
 try {
 await api(`/os/projekter/${redigerModal.id}/feedback`, "PATCH", {
 rene_feedback: redigerData.rene_feedback || null,
 fejlbeskrivelse: redigerData.fejlbeskrivelse || null
 });
 setRedigerModal(null);
 await hent();
 } finally {
 setGemmerFeedback(false);
 }
 }
 async function tilknytIdee() {
 if (!redigerModal || !redigerData.ny_ide?.trim()) return;
 setGemmerFeedback(true);
 try {
 await api("/os/ideer", "POST", {
 tekst: `[Projekt: ${redigerModal.titel}] ${redigerData.ny_ide.trim()}`,
 oprettet_af: "rene"
 });
 setRedigerData(prev => ({ ...prev, ny_ide: "" }));
 setRedigerModal(null);
 await hent();
 } finally {
 setGemmerFeedback(false);
 }
 }
 async function korVidere() {
 if (!redigerModal) return;
 const kommentar = (redigerData.fejlbeskrivelse || redigerData.rene_feedback || "Kør videre med ny kontekst").trim();
 setGemmerFeedback(true);
 try {
 if (redigerData.rene_feedback || redigerData.fejlbeskrivelse) {
 await api(`/os/projekter/${redigerModal.id}/feedback`, "PATCH", {
 rene_feedback: redigerData.rene_feedback || null,
 fejlbeskrivelse: redigerData.fejlbeskrivelse || null
 });
 }
 await api(`/os/projekter/${redigerModal.id}/modificer`, "PATCH", { kommentar });
 setRedigerModal(null);
 await hent();
 } finally {
 setGemmerFeedback(false);
 }
 }
 async function modificerProjekt(p) {
 const tekst = (modificerTekst[p.id] || "").trim();
 if (!tekst) return;
 setHandlinger(prev => ({ ...prev, [p.id]: "loading" }));
 try {
 await api(`/os/projekter/${p.id}/modificer`, "PATCH", { kommentar: tekst });
 setModificerTekst(prev => { const n = { ...prev }; delete n[p.id]; return n; });
 await hent();
 } finally {
 setHandlinger(prev => { const n = { ...prev }; delete n[p.id]; return n; });
 }
 }
 return (
 <div> <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}> <div style={{ fontSize: 13, color: "#7a8fa6" }}>
 {loader ? "Henter…" : `${projekter.filter(p => p.status !== 'ANNULLERET').length} projekter`}
 </div> <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
 {projekter.some(p => p.status === 'ANNULLERET') && (
 <button onClick={() => setVisAnnullerede(v => !v)} style={{ background: "none", border: KANT, borderRadius: 6,
 color: visAnnullerede ? "#e2e8f0" : "#64748b", cursor: "pointer", fontSize: 11, padding: "4px 10px" }}>
 {visAnnullerede ? "Skjul annullerede" : `Vis annullerede (${projekter.filter(p => p.status === 'ANNULLERET').length})`}
 </button>
 )}
 <button onClick={hent} style={{ background: "none", border: KANT, borderRadius: 6,
 color: "#64748b", cursor: "pointer", fontSize: 11, padding: "4px 10px" }}>
 ↻ Opdater
 </button> </div> </div>
 {/* Godkendt-bekræftelse */}
 {godkendtBesked && (
 <div style={{ marginBottom: 16, padding: "10px 16px", background: "rgba(34,197,94,0.12)",
 border: "1px solid rgba(34,197,94,0.35)", borderRadius: 10,
 fontSize: 13, fontWeight: 600, color: GROEN, display: "flex", alignItems: "center", gap: 8 }}> <span style={{ fontSize: 16 }}></span>
 {godkendtBesked} — agenten er notificeret
 </div>
 )}
 {!loader && projekter.length === 0 && (
 <div style={{ color: "#4a5568", fontSize: 14, padding: "48px 0", textAlign: "center" }}>
 Ingen projekter endnu — godkend en idé for at starte et projekt
 </div>
 )}
 {/* ── Afventer din godkendelse ──────────────────────────── */}
 {afventerGodkendelse.length > 0 && (
 <div style={{ marginBottom: 24 }}> <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}> <div style={{ width: 8, height: 8, borderRadius: "50%", background: AMBER,
 boxShadow: `0 0 8px ${AMBER}` }} /> <span style={{ fontSize: 13, fontWeight: 700, color: AMBER, textTransform: "uppercase", letterSpacing: 0.6 }}>
 Klar til deploy
 </span> <span style={{ fontSize: 11, background: `${AMBER}22`, color: AMBER,
 borderRadius: 10, padding: "1px 8px", fontWeight: 700 }}>
 {afventerGodkendelse.length}
 </span> </div>
 {afventerGodkendelse.map(p => {
 const fase = getNuværendeFase(p);
 const faseOpgaver = fase ? (p.opgaver || []).filter(o => o.fase_id === fase.id) : [];
 const lader = handlinger[p.id] === "loading";
 const visMod = handlinger[p.id] === "modificer";
 const erRevision = fase && fase.fase_nummer > 1;
 return (
 <div key={p.id} style={{
 background: "rgba(243,156,18,0.06)", border: `1px solid ${AMBER}40`,
 borderRadius: 14, padding: "16px 20px", marginBottom: 12,
 borderLeft: `4px solid ${AMBER}` }}> <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}> <div style={{ flex: 1 }}> <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 4 }}> {p.projekt_nummer != null && (
                        <span style={{ fontSize: 11, fontWeight: 800, color: "#94a3b8",
                          background: "rgba(148,163,184,0.12)", borderRadius: 5,
                          padding: "2px 7px", letterSpacing: "0.02em", flexShrink: 0 }}>
                          {`P-${String(p.projekt_nummer).padStart(3, "0")}`}
                        </span>
                      )} <div style={{ fontSize: 14, fontWeight: 700, color: "#e2e8f0" }}>{p.titel}</div>
 {erRevision && (
 <span style={{ fontSize: 10, fontWeight: 700, color: AMBER,
 background: `${AMBER}20`, borderRadius: 5, padding: "2px 8px" }}>
 Fase {fase.fase_nummer}
 </span>
 )}
 </div>
 {p.estimat_tid && (
 <div style={{ fontSize: 11, color: "#9db3c8", marginBottom: 6 }}>
 Estimat: {p.estimat_tid}
 {p.impact_score && <> · Impact {p.impact_score}/10</>}
 </div>
 )}
 <div style={{ fontSize: 11, color: "#64748b" }}>
 {fase
 ? <>{faseOpgaver.length} afdeling{faseOpgaver.length !== 1 ? "er" : ""} har leveret{erRevision && <span style={{ color: AMBER }}> · revision</span>}</>
 : <span style={{ color: GROEN }}> Alle faser fuldført — klar til deploy</span>
 }
 </div> </div>
 {!visMod && (
 <div style={{ display: "flex", gap: 8, flexShrink: 0 }}> <button disabled={lader} onClick={() => godkendProjekt(p)} style={{
 padding: "7px 18px", background: "rgba(34,197,94,0.15)", border: "1px solid rgba(34,197,94,0.4)",
 borderRadius: 8, color: GROEN, fontWeight: 700, fontSize: 13,
 cursor: lader ? "default" : "pointer", opacity: lader ? 0.5 : 1 }}>
 {lader ? "…" : " Start deploy"}
 </button> <button disabled={lader} onClick={() => afvisProjekt(p)} style={{
 padding: "7px 18px", background: "rgba(231,76,60,0.12)", border: "1px solid rgba(231,76,60,0.3)",
 borderRadius: 8, color: ROED, fontWeight: 700, fontSize: 13,
 cursor: lader ? "default" : "pointer", opacity: lader ? 0.5 : 1 }}>
 Afvis
 </button> </div>
 )}
 </div>
 {/* Leverance-resumé fra nuværende fase */}
 {faseOpgaver.filter(o => o.status === "FULDFOERT" && o.resultat).slice(0, 1).map(o => {
 try {
 const res = typeof o.resultat === "string" ? JSON.parse(o.resultat) : o.resultat;
 if (!res?.leverance) return null;
 return (
 <div key={o.id} style={{ marginTop: 10, background: "rgba(0,0,0,0.2)",
 borderRadius: 8, padding: "8px 12px" }}> <div style={{ fontSize: 10, color: "#64748b", fontWeight: 700, marginBottom: 4,
 textTransform: "uppercase", letterSpacing: 0.5 }}>
 {afdLabel(o.afdeling)} — Leverance (uddrag)
 </div> <div style={{ fontSize: 12, color: "#9db3c8", lineHeight: 1.5,
 maxHeight: 80, overflow: "hidden", whiteSpace: "pre-wrap" }}>
 {res.leverance.slice(0, 280)}{res.leverance.length > 280 ? "…" : ""}
 </div> </div>
 );
 } catch { return null; }
 })}
 {/* Modificer-dialog */}
 {visMod && (
 <div style={{ marginTop: 12 }}> <div style={{ fontSize: 12, color: AMBER, fontWeight: 600, marginBottom: 4 }}>
 Skriv instruktion til agenterne
 </div> <div style={{ fontSize: 11, color: "#4a5568", marginBottom: 8 }}>
 Den nuværende leverance gemmes som {erRevision ? `Fase ${fase.fase_nummer} (Revideret)` : "Fase 1 (Revideret)"}. En ny fase starter.
 </div> <textarea
 value={modificerTekst[p.id] || ""}
 onChange={e => setModificerTekst(prev => ({ ...prev, [p.id]: e.target.value }))}
 rows={3}
 placeholder="Fx: Kode-leverancen skal fokusere mere på mobile brugere…"
 style={{ width: "100%", boxSizing: "border-box", background: "rgba(255,255,255,0.04)",
 border: `1px solid ${AMBER}40`, borderRadius: 8, color: "#e8eaf6",
 padding: "8px 12px", fontSize: 12, resize: "vertical", fontFamily: "inherit" }}
 /> <div style={{ display: "flex", gap: 8, marginTop: 8 }}> <button onClick={() => modificerProjekt(p)} disabled={!(modificerTekst[p.id] || "").trim()} style={{
 padding: "7px 18px", background: "rgba(243,156,18,0.15)", border: `1px solid ${AMBER}60`,
 borderRadius: 8, color: AMBER, fontWeight: 700, fontSize: 12,
 cursor: (modificerTekst[p.id] || "").trim() ? "pointer" : "not-allowed",
 opacity: (modificerTekst[p.id] || "").trim() ? 1 : 0.5 }}>
 Start ny fase
 </button> <button onClick={() => setHandlinger(prev => { const n = { ...prev }; delete n[p.id]; return n; })} style={{
 padding: "7px 14px", background: "none", border: KANT,
 borderRadius: 8, color: "#64748b", cursor: "pointer", fontSize: 12 }}>
 Annuller
 </button> </div> </div>
 )}
 </div>
 );
 })}
 <div style={{ borderBottom: "1px solid rgba(63,212,199,0.08)", marginBottom: 20 }} /> </div>
 )}
 {(visAnnullerede ? projekter : projekter.filter(p => p.status !== 'ANNULLERET')).map(p => {
 // Brug afledt_status (beregnet af backend fra faser) til header-visning.
 // Fallback til p.status hvis feltet ikke er tilgængeligt (gammel API-version).
 const visStatus = p.afledt_status || p.status;
 const cfg = PROJEKT_STATUS_CFG[visStatus] || PROJEKT_STATUS_CFG.PLANLAGT;
 const er_udvidet = !!udvidet[p.id];
 const analyse = p.idee_analyse || {};
 const opgaver = Array.isArray(p.opgaver) ? p.opgaver : [];
 const faser = Array.isArray(p.faser) ? p.faser : [];
 const harFlereFaser = faser.length >= 1;
 const alle_afdelinger = p.alle_afdelinger || [p.ansvarlig_afdeling];
 const nuværendeFase = getNuværendeFase(p);
 const nuværendeFaseOpgaver = nuværendeFase
 ? opgaver.filter(o => o.fase_id === nuværendeFase.id)
 : opgaver;
 return (
 <div key={p.id} style={{ background: BG, border: KANT, borderRadius: 14,
 padding: "16px 20px", marginBottom: 14, borderLeft: `3px solid ${cfg.farve}` }}>
 {/* Hoved-info */}
 <div style={{ marginBottom: 8 }}> <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 4 }}> {p.projekt_nummer != null && (
                  <span style={{ fontSize: 11, fontWeight: 800, color: "#94a3b8",
                    background: "rgba(148,163,184,0.12)", borderRadius: 5,
                    padding: "2px 7px", letterSpacing: "0.02em", flexShrink: 0 }}>
                    {`P-${String(p.projekt_nummer).padStart(3, "0")}`}
                  </span>
                )} <span style={{ fontSize: 14, fontWeight: 700, color: "#e2e8f0" }}>{p.titel}</span> <span style={{ fontSize: 10, fontWeight: 700, color: cfg.farve,
 background: `${cfg.farve}20`, borderRadius: 5, padding: "2px 8px", textTransform: "uppercase" }}>
 {cfg.label}
 </span>
 {p.impact_score && (
 <span style={{ fontSize: 10, fontWeight: 700, color: ACCENT, background: "rgba(63,212,199,0.1)",
 borderRadius: 5, padding: "2px 8px" }}>
 Impact {p.impact_score}/10
 </span>
 )}
 {harFlereFaser && (
 <span style={{ fontSize: 10, color: "#64748b", background: "rgba(255,255,255,0.05)",
 borderRadius: 5, padding: "2px 8px" }}>
 {faser.length} faser
 </span>
 )}
 </div> <div style={{ fontSize: 11, color: "#64748b" }}>
 Oprettet: {formatTid(p.oprettet_kl)}
 {p.estimat_tid && <> · <span style={{ color: "#9db3c8" }}>{p.estimat_tid}</span></>}
 {p.pr_url && p.deploy_kl && (
 <> · <span style={{ color: GROEN }}>
 Live {formatTid(p.deploy_kl)}{p.deploy_sha && p.deploy_sha !== "ukendt" ? ` · ${p.deploy_sha}` : ""}
 </span></>
 )}
 {!p.deploy_kl && faser.some(f =>
 ((f.fase_navn || "").toLowerCase().includes("kode-implementering") || f.fase_nummer === 3) &&
 f.status === "IGANGVAERENDE") && (
 <> · <span style={{ color: LILLA }}> Kode-implementering aktiv</span></>
 )}
 </div> </div>
 {/* Afdelings-chips (nuværende fase) */}
 <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginBottom: 10 }}>
 {alle_afdelinger.map(afd => {
 const opgave = nuværendeFaseOpgaver.find(o => o.afdeling === afd);
 const o_cfg = opgave ? (OPGAVE_STATUS_CFG[opgave.status] || OPGAVE_STATUS_CFG.AFVENTER) : null;
 const er_lead = afd === p.ansvarlig_afdeling;
 return (
 <div key={afd} style={{
 display: "flex", alignItems: "center", gap: 5,
 padding: "3px 10px", borderRadius: 20, fontSize: 11,
 background: er_lead ? "rgba(63,212,199,0.12)" : "rgba(255,255,255,0.04)",
 border: er_lead ? "1px solid rgba(63,212,199,0.3)" : KANT,
 color: er_lead ? ACCENT : "#9db3c8",
 fontWeight: er_lead ? 700 : 400 }}>
 {o_cfg && (
 <div style={{ width: 5, height: 5, borderRadius: "50%", background: o_cfg.farve,
 boxShadow: opgave?.status === "KOERER" ? `0 0 5px ${o_cfg.farve}` : "none" }} />
 )}
 {afdLabel(afd)}
 {er_lead && <span style={{ fontSize: 9, opacity: 0.6 }}> lead</span>}
 </div>
 );
 })}
 </div>
 {/* Renés instruktion */}
 {p.rene_kommentar && (
 <div style={{ background: "rgba(63,212,199,0.06)", border: "1px solid rgba(63,212,199,0.15)",
 borderRadius: 8, padding: "8px 12px", marginBottom: 10 }}> <div style={{ fontSize: 10, fontWeight: 700, color: ACCENT, textTransform: "uppercase",
 letterSpacing: 0.5, marginBottom: 3 }}>Renés instruktion</div> <div style={{ fontSize: 12, color: "#9db3c8", lineHeight: 1.5 }}>{p.rene_kommentar}</div> </div>
 )}
 {/* Opgave-status (nuværende fase) */}
 {nuværendeFaseOpgaver.length > 0 && (
 <div style={{ display: "flex", flexDirection: "column", gap: 4, marginBottom: 10 }}>
 {nuværendeFaseOpgaver.map(o => {
 const o_cfg = OPGAVE_STATUS_CFG[o.status] || OPGAVE_STATUS_CFG.AFVENTER;
 const er_lead = o.afdeling_rolle === "lead";
 return (
 <div key={o.id} style={{
 background: "rgba(0,0,0,0.2)", borderRadius: 7, padding: "7px 12px",
 display: "flex", alignItems: "center", gap: 10,
 borderLeft: er_lead ? `2px solid ${o_cfg.farve}60` : "none" }}> <div style={{ width: 6, height: 6, borderRadius: "50%", background: o_cfg.farve, flexShrink: 0,
 boxShadow: o.status === "KOERER" ? `0 0 6px ${o_cfg.farve}` : "none",
 animation: o.status === "KOERER" ? "pulse 2s ease-in-out infinite" : "none" }} /> <div style={{ flex: 1, fontSize: 12, color: "#7a8fa6" }}> <span style={{ color: er_lead ? "#9db3c8" : "#64748b", fontWeight: er_lead ? 600 : 400 }}>
 {afdLabel(o.afdeling)}
 </span>
 {" — "}
 <span style={{ color: o_cfg.farve, fontWeight: 600 }}>{o_cfg.label}</span> </div> <div style={{ fontSize: 10, color: "#4a5568" }}>
 {o.afsluttet_kl ? formatTid(o.afsluttet_kl) : formatTid(o.oprettet_kl)}
 </div> </div>
 );
 })}
 </div>
 )}
 {nuværendeFaseOpgaver.length === 0 && opgaver.length === 0 && (
 <div style={{ fontSize: 11, color: "#4a5568", marginBottom: 8, fontStyle: "italic" }}>
 Ingen agent-opgaver tilknyttet endnu
 </div>
 )}
 {/* Seneste agent-aktivitet — live indikator på kortet */}
 {(() => {
 if (!nuværendeFase) return null;
 const log = Array.isArray(nuværendeFase.aktivitet_log) ? nuværendeFase.aktivitet_log : [];
 const sidst = log[log.length - 1];
 if (!sidst) return null;
 const minSiden = sidst.tidspunkt
 ? Math.round((Date.now() - new Date(sidst.tidspunkt)) / 60000)
 : null;
 // Farv indikatoren efter vis-status: grøn = aktiv, gul = afventer, rød = i stå
 const indikatorFarve = visStatus === "IGANGVAERENDE" ? ACCENT
 : visStatus === "AFVENTER_AGENT" ? AMBER
 : visStatus === "GAAET_I_STAA" ? ROED
 : ACCENT;
 // Kun pulsér hvis reelt aktiv (< 30 min)
 const skalPulsere = visStatus === "IGANGVAERENDE";
 return (
 <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8,
 fontSize: 11, color: "#4a5568" }}> <span style={{ width: 5, height: 5, borderRadius: "50%", background: indikatorFarve,
 flexShrink: 0, boxShadow: skalPulsere ? `0 0 5px ${indikatorFarve}` : "none",
 display: "inline-block",
 animation: skalPulsere ? "pulse 2s ease-in-out infinite" : "none" }} /> <span style={{ color: indikatorFarve, fontWeight: 600 }}>{sidst.agent}</span> <span style={{ color: "#4a5568" }}>—</span> <span style={{ color: "#64748b", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
 {sidst.besked}
 </span>
 {minSiden !== null && (
 <span style={{ flexShrink: 0, color: "#3a4a5a" }}>
 {minSiden < 1 ? "< 1 min siden" : `${minSiden} min siden`}
 </span>
 )}
 </div>
 );
 })()}
 {/* Expandable */}
 <div style={{ display: "flex", alignItems: "center", gap: 10 }}> <button onClick={() => toggleUdvidet(p.id)} style={{
 background: "none", border: "none", color: "#4a5568", cursor: "pointer",
 fontSize: 11, padding: "3px 0", display: "flex", alignItems: "center", gap: 4 }}> <span style={{ transition: "transform .15s", display: "inline-block",
 transform: er_udvidet ? "rotate(90deg)" : "none" }}>▶</span>
 {er_udvidet ? "Skjul detaljer" : "Vis forløb & detaljer"}
 </button> <button onClick={() => aabneRedigering(p)} style={{
 background: "none", border: KANT, borderRadius: 6, color: "#64748b",
 cursor: "pointer", fontSize: 11, padding: "3px 10px" }}>
 Rediger
 </button> </div>
 {er_udvidet && (
 <div style={{ marginTop: 10, borderTop: "1px solid rgba(255,255,255,0.05)", paddingTop: 10 }}>
 {/* Renés noter og fejlbeskrivelse */}
 {(p.fejlbeskrivelse || p.rene_feedback) && (
 <div style={{ background: `${AMBER}08`, border: `1px solid ${AMBER}20`,
 borderRadius: 8, padding: "10px 14px", marginBottom: 14 }}>
 {p.fejlbeskrivelse && (
 <div style={{ marginBottom: p.rene_feedback ? 8 : 0 }}> <div style={{ fontSize: 10, fontWeight: 700, color: AMBER, textTransform: "uppercase",
 letterSpacing: 0.5, marginBottom: 4 }}>Hvad virker / virker ikke</div> <div style={{ fontSize: 12, color: "#9db3c8", lineHeight: 1.5 }}>{p.fejlbeskrivelse}</div> </div>
 )}
 {p.rene_feedback && (
 <div> <div style={{ fontSize: 10, fontWeight: 700, color: AMBER, textTransform: "uppercase",
 letterSpacing: 0.5, marginBottom: 4 }}>Renés noter</div> <div style={{ fontSize: 12, color: "#9db3c8", lineHeight: 1.5 }}>{p.rene_feedback}</div> </div>
 )}
 </div>
 )}
 {/* Fase-tidslinje */}
 {harFlereFaser && (
 <div style={{ marginBottom: 16 }}> <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700, marginBottom: 8,
 textTransform: "uppercase", letterSpacing: 0.5 }}>Projektforløb</div> <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
 {faser.map((f, i) => {
 // Brug afledt_fase_status (aktivitetsbaseret) til visning — fallback til rå status
 const fasVisStatus = f.afledt_fase_status || f.status;
 const f_cfg = FASE_STATUS_CFG[fasVisStatus] || FASE_STATUS_CFG.PLANLAGT;
 const fOpgaver = opgaver.filter(o => o.fase_id === f.id);
 const erSidst = i === faser.length - 1;
 const erPlanlagt = f.status === "PLANLAGT";
 // erAktiv: fase er IGANGVAERENDE i DB (rå), uanset aktivitetsniveau
 const erAktiv = f.status === "IGANGVAERENDE";
 // erReeltAktiv: agent arbejdede faktisk inden for 30 min → grøn puls
 const erReeltAktiv = fasVisStatus === "IGANGVAERENDE";
 const aktivLog = Array.isArray(f.aktivitet_log) ? f.aktivitet_log : [];
 const senestLog = aktivLog.slice(-5);
 const planlagteAfdelinger = erPlanlagt && Array.isArray(f.afdelinger) ? f.afdelinger : [];
 return (
 <div key={f.id} style={{ display: "flex", gap: 12, paddingBottom: erSidst ? 0 : 12,
 opacity: erPlanlagt ? 0.55 : 1 }}>
 {/* Tidslinje-søjle */}
 <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: 16 }}> <div style={{ width: erAktiv ? 12 : 9, height: erAktiv ? 12 : 9, borderRadius: "50%",
 background: erPlanlagt ? "rgba(255,255,255,0.12)" : f_cfg.farve,
 border: erPlanlagt ? "1.5px dashed #4a5568" : "none",
 // Kun puls/glow hvis agent reelt er aktiv (< 30 min) — ikke ved Afventer/Gået i stå
 boxShadow: erReeltAktiv ? `0 0 8px ${f_cfg.farve}` : "none",
 flexShrink: 0, marginTop: 3 }} />
 {!erSidst && (
 <div style={{ width: 2, flex: 1, background: erPlanlagt ? "rgba(255,255,255,0.04)" : "rgba(255,255,255,0.08)",
 marginTop: 4, borderLeft: erPlanlagt ? "2px dashed rgba(255,255,255,0.1)" : "none" }} />
 )}
 </div>
 {/* Fase-indhold */}
 <div style={{ flex: 1, paddingBottom: erSidst ? 0 : 4 }}> <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}> <span style={{ fontSize: 12, fontWeight: 700,
 color: erPlanlagt ? "#64748b" : f_cfg.farve }}>
 {f.fase_navn}
 </span> <span style={{ fontSize: 10,
 color: erPlanlagt ? "#4a5568" : f_cfg.farve,
 background: erPlanlagt ? "rgba(255,255,255,0.05)" : `${f_cfg.farve}15`,
 borderRadius: 4, padding: "1px 6px", textTransform: "uppercase" }}>
 {f_cfg.label}
 </span>
 {!erPlanlagt && (
 <span style={{ fontSize: 10, color: "#4a5568", marginLeft: "auto" }}>
 {formatTid(f.oprettet_kl)}
 </span>
 )}
 </div>
 {/* Planlagte afdelinger — chips */}
 {planlagteAfdelinger.length > 0 && (
 <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 4 }}>
 {planlagteAfdelinger.map(a => (
 <span key={a} style={{ fontSize: 10, color: "#4a5568",
 background: "rgba(255,255,255,0.04)",
 borderRadius: 4, padding: "1px 6px", border: "1px dashed rgba(255,255,255,0.08)" }}>
 {afdLabel(a)}
 </span>
 ))}
 </div>
 )}
 {f.rene_kommentar && (
 <div style={{ fontSize: 11, color: AMBER, background: `${AMBER}10`,
 borderRadius: 6, padding: "4px 8px", marginBottom: 4 }}>
 René: {f.rene_kommentar}
 </div>
 )}
 {fOpgaver.length > 0 && !erPlanlagt && (
 <div style={{ fontSize: 11, color: "#4a5568", marginBottom: senestLog.length > 0 ? 4 : 0 }}>
 {fOpgaver.filter(o => o.status === "FULDFOERT").length}/{fOpgaver.length} leverancer fuldført
 </div>
 )}
 {/* Realtids aktivitet-log for IGANGVAERENDE fase (vises altid når log findes) */}
 {erAktiv && senestLog.length > 0 && (
 <div style={{ background: "rgba(0,0,0,0.3)", borderRadius: 8, padding: "8px 10px",
 marginTop: 4, borderLeft: `2px solid ${f_cfg.farve}40` }}> <div style={{ fontSize: 10, color: f_cfg.farve, fontWeight: 700,
 marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.5 }}>
 {/* Vis "Seneste aktivitet" i stedet for "Agent-aktivitet" ved gul/rød */}
 {erReeltAktiv ? "Agent-aktivitet" : "Seneste aktivitet"}
 </div>
 {senestLog.map((entry, ei) => (
 <div key={ei} style={{ display: "flex", gap: 8, marginBottom: ei < senestLog.length - 1 ? 4 : 0,
 alignItems: "flex-start" }}> <span style={{ fontSize: 10, color: "#3fd4c7", fontWeight: 600,
 flexShrink: 0, minWidth: 60 }}>
 {entry.agent}
 </span> <span style={{ fontSize: 11, color: "#8fa7bf", lineHeight: 1.4, flex: 1 }}>
 {entry.besked}
 </span> <span style={{ fontSize: 9, color: "#4a5568", flexShrink: 0 }}>
 {entry.tidspunkt ? new Date(entry.tidspunkt).toLocaleTimeString("da-DK", {hour:"2-digit",minute:"2-digit",second:"2-digit"}) : ""}
 </span> </div>
 ))}
 </div>
 )}
 {/* "Arbejder..." indikator — kun hvis reelt aktiv (< 30 min) og KOERER-opgave */}
 {erReeltAktiv && fOpgaver.some(o => o.status === "KOERER") && senestLog.length === 0 && (
 <div style={{ fontSize: 11, color: f_cfg.farve, display: "flex", alignItems: "center", gap: 6, marginTop: 4 }}> <span style={{ display: "inline-block", width: 6, height: 6, borderRadius: "50%",
 background: f_cfg.farve, animation: "pulse 1.5s infinite" }} />
 Agent arbejder...
 </div>
 )}
 {/* Advarsel hvis fase er gået i stå (ingen aktivitet > 4 timer) */}
 {fasVisStatus === "GAAET_I_STAA" && (
 <div style={{ fontSize: 11, color: ROED, display: "flex", alignItems: "center", gap: 6, marginTop: 4,
 background: `${ROED}10`, borderRadius: 6, padding: "4px 8px" }}> <span></span>
 Ingen agent-aktivitet i &gt;4 timer — fasen kan kræve manuel opfølgning
 </div>
 )}
 </div> </div>
 );
 })}
 </div> </div>
 )}
 {/* Analyse vurdering */}
 {analyse.vurdering && (
 <div style={{ background: "rgba(0,0,0,0.25)", borderRadius: 8, padding: "10px 12px", marginBottom: 8 }}> <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700, marginBottom: 4,
 textTransform: "uppercase", letterSpacing: 0.5 }}>Analyse-vurdering</div> <div style={{ fontSize: 12, color: "#9db3c8", lineHeight: 1.6 }}>{analyse.vurdering}</div>
 {analyse.roi && <div style={{ fontSize: 11, color: AMBER, marginTop: 4 }}>ROI: {analyse.roi}</div>}
 </div>
 )}
 {/* Original idé */}
 {p.idee_tekst && (
 <div style={{ fontSize: 11, color: "#4a5568", background: "rgba(0,0,0,0.2)",
 borderRadius: 6, padding: "6px 10px", marginBottom: 8 }}> <span style={{ color: "#64748b", fontWeight: 600 }}>Idé: </span>{p.idee_tekst}
 </div>
 )}
 {/* Agent-resultater fra nuværende fase */}
 {nuværendeFaseOpgaver.filter(o => o.resultat && o.status === "FULDFOERT").map(o => {
 try {
 const res = typeof o.resultat === "string" ? JSON.parse(o.resultat) : o.resultat;
 if (!res || Object.keys(res).length === 0) return null;
 const naeste = Array.isArray(res.naeste_skridt) ? res.naeste_skridt : [];
 return (
 <div key={o.id} style={{ background: "rgba(0,0,0,0.25)", borderRadius: 8,
 padding: "10px 12px", marginBottom: 6 }}> <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700, marginBottom: 6,
 textTransform: "uppercase", letterSpacing: 0.5 }}>
 {afdLabel(o.afdeling)} — Leverance
 </div>
 {res.leverance && (
 <div style={{ fontSize: 12, color: "#9db3c8", lineHeight: 1.6, marginBottom: naeste.length ? 8 : 0,
 maxHeight: 140, overflow: "auto", whiteSpace: "pre-wrap" }}>
 {res.leverance}
 </div>
 )}
 {naeste.length > 0 && (
 <div> <div style={{ fontSize: 10, color: "#64748b", fontWeight: 700, marginBottom: 4,
 textTransform: "uppercase", letterSpacing: 0.5 }}>Næste skridt</div>
 {naeste.map((s, i) => (
 <div key={i} style={{ fontSize: 11, color: "#7a8fa6", display: "flex", gap: 6,
 marginBottom: 2, lineHeight: 1.5 }}> <span style={{ color: GROEN, flexShrink: 0 }}>→</span> <span>{s}</span> </div>
 ))}
 </div>
 )}
 {res.kraever_godkendelse && (
 <div style={{ marginTop: 6, fontSize: 11, color: AMBER }}>
 Kræver Renés godkendelse inden implementering
 </div>
 )}
 </div>
 );
 } catch { return null; }
 })}
 </div>
 )}
 </div>
 );
 })}
 {/* Rediger-modal */}
 {redigerModal && (
 <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", zIndex: 9999,
 display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}> <div style={{ background: "#0d1117", border: "1px solid rgba(63,212,199,0.2)",
 borderRadius: 16, padding: 24, width: "100%", maxWidth: 520, maxHeight: "90vh", overflowY: "auto" }}> <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}> <div style={{ fontSize: 14, fontWeight: 700, color: "#e2e8f0" }}>Rediger projekt</div> <button onClick={() => setRedigerModal(null)} style={{ background: "none", border: "none",
 color: "#64748b", cursor: "pointer", fontSize: 22, lineHeight: 1, padding: "0 2px" }}>×</button> </div> <div style={{ fontSize: 11, color: "#64748b", marginBottom: 20,
 overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
 {redigerModal.titel}
 </div> <div style={{ marginBottom: 14 }}> <label style={{ fontSize: 10, fontWeight: 700, color: "#64748b", textTransform: "uppercase",
 letterSpacing: 0.5, display: "block", marginBottom: 6 }}>
 Hvad virker / hvad virker ikke
 </label> <textarea value={redigerData.fejlbeskrivelse || ""}
 onChange={e => setRedigerData(prev => ({ ...prev, fejlbeskrivelse: e.target.value }))}
 rows={3} placeholder="Beskriv hvad der virker og hvad der ikke gør…"
 style={{ width: "100%", background: "rgba(255,255,255,0.04)", border: KANT,
 borderRadius: 8, color: "#e2e8f0", fontSize: 12, padding: "8px 12px",
 resize: "vertical", lineHeight: 1.5, boxSizing: "border-box" }} /> </div> <div style={{ marginBottom: 14 }}> <label style={{ fontSize: 10, fontWeight: 700, color: "#64748b", textTransform: "uppercase",
 letterSpacing: 0.5, display: "block", marginBottom: 6 }}>
 Renés noter og feedback
 </label> <textarea value={redigerData.rene_feedback || ""}
 onChange={e => setRedigerData(prev => ({ ...prev, rene_feedback: e.target.value }))}
 rows={3} placeholder="Dine noter til projektet…"
 style={{ width: "100%", background: "rgba(255,255,255,0.04)", border: KANT,
 borderRadius: 8, color: "#e2e8f0", fontSize: 12, padding: "8px 12px",
 resize: "vertical", lineHeight: 1.5, boxSizing: "border-box" }} /> </div> <div style={{ marginBottom: 22 }}> <label style={{ fontSize: 10, fontWeight: 700, color: "#64748b", textTransform: "uppercase",
 letterSpacing: 0.5, display: "block", marginBottom: 6 }}>
 Tilknyt ny idé
 </label> <div style={{ display: "flex", gap: 8, alignItems: "flex-end" }}> <textarea value={redigerData.ny_ide || ""}
 onChange={e => setRedigerData(prev => ({ ...prev, ny_ide: e.target.value }))}
 rows={2} placeholder="Beskriv en ny idé der hænger sammen med dette projekt…"
 style={{ flex: 1, background: "rgba(255,255,255,0.04)", border: KANT,
 borderRadius: 8, color: "#e2e8f0", fontSize: 12, padding: "8px 12px",
 resize: "vertical", lineHeight: 1.5 }} /> <button onClick={tilknytIdee}
 disabled={!redigerData.ny_ide?.trim() || gemmerFeedback}
 style={{ height: 36, padding: "0 14px", borderRadius: 8, fontSize: 11, fontWeight: 600,
 background: redigerData.ny_ide?.trim() ? "rgba(63,212,199,0.12)" : "rgba(255,255,255,0.04)",
 border: KANT, color: redigerData.ny_ide?.trim() ? ACCENT : "#4a5568",
 cursor: redigerData.ny_ide?.trim() && !gemmerFeedback ? "pointer" : "default",
 whiteSpace: "nowrap" }}>
 + Send idé
 </button> </div> </div> <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", flexWrap: "wrap" }}> <button onClick={() => setRedigerModal(null)}
 style={{ background: "none", border: KANT, borderRadius: 8, color: "#64748b",
 cursor: "pointer", fontSize: 12, padding: "8px 16px" }}>
 Luk
 </button> <button onClick={gemFeedback} disabled={gemmerFeedback}
 style={{ background: "rgba(255,255,255,0.06)", border: KANT, borderRadius: 8,
 color: "#9db3c8", cursor: gemmerFeedback ? "default" : "pointer",
 fontSize: 12, padding: "8px 16px" }}>
 {gemmerFeedback ? "Gemmer…" : "Gem noter"}
 </button> <button onClick={korVidere} disabled={gemmerFeedback}
 style={{ background: `${ACCENT}15`, border: `1px solid ${ACCENT}40`, borderRadius: 8,
 color: ACCENT, fontWeight: 700, cursor: gemmerFeedback ? "default" : "pointer",
 fontSize: 12, padding: "8px 16px" }}>
 {gemmerFeedback ? "…" : "↺ Kør videre"}
 </button> </div> </div> </div>
 )}
 </div>
 );
}
// ── HOVED-KOMPONENT ─────────────────────────────────────────────
export default function OSIdeePipeline({ defaultFane = "ideer" } = {}) {
 const [fane, setFane] = useState(defaultFane);
 const [afventer_analyse, setAfventerAnalyse] = useState(0);
 const [afventer_godkendelse, setAfventerGodkendelse] = useState(0);
 React.useEffect(() => {
 const id = "ide-spinner-style";
 if (!document.getElementById(id)) {
 const s = document.createElement("style");
 s.id = id;
 s.textContent = SPINNER_STYLE;
 document.head.appendChild(s);
 }
 }, []);
 const faner = [
 { id: "ideer", label: "Idéer", badge: afventer_analyse || null },
 { id: "projekter", label: "Projekter", badge: afventer_godkendelse || null },
 ];
 return (
 <div> <h1 style={{ fontSize: 22, fontWeight: 800, color: "#f1f5f9", marginBottom: 6 }}>Idéer & Initiativer</h1> <p style={{ fontSize: 13, color: "#64748b", marginBottom: 24 }}>
 Idé-pipeline — fra tanke til projekt. Send en idé, få analyse, og godkend med ét klik.
 </p> <div style={{ display: "flex", gap: 4, marginBottom: 24, borderBottom: "1px solid rgba(63,212,199,0.1)" }}>
 {faner.map(f => (
 <button key={f.id} onClick={() => setFane(f.id)} style={{
 padding: "8px 18px", border: "none", background: "none", cursor: "pointer",
 fontSize: 13, fontWeight: fane === f.id ? 700 : 400,
 color: fane === f.id ? ACCENT : "#64748b",
 borderBottom: fane === f.id ? `2px solid ${ACCENT}` : "2px solid transparent",
 marginBottom: -1, display: "flex", alignItems: "center", gap: 6 }}>
 {f.label}
 {f.badge > 0 && (
 <span style={{ background: ROED, color: "#fff", borderRadius: 10,
 fontSize: 10, fontWeight: 700, padding: "1px 6px" }}>
 {f.badge}
 </span>
 )}
 </button>
 ))}
 </div>
 {fane === "ideer" && <IdeerFane onOpdaterTæller={setAfventerAnalyse} />}
 {fane === "projekter" && <ProjekterFane onAfventerTæller={setAfventerGodkendelse} />}
 </div>
 );
}